import DragIcon from "@assets/images/drag_indicator.svg";
import plusIcon from "@assets/images/plus-teal.svg";
import Trash from "@assets/images/trash-teal.svg";
import { Box, Grid } from "@material-ui/core";
import InputSuggestion from "@saleor/alternatedMaterial/components/InputSuggestionForPrioridy";
import DragHandle from "@saleor/components/Draggable";
import MyTypography from "@saleor/components/MyTypography";
import SingleTextField from "@saleor/components/SingleTextField";
import {
  useGradeGramLazyQuery,
  useMaterialOwnLazyQuery
} from "@saleor/graphql";
import { mapEdgesToItems } from "@saleor/utils/maps";
import moment from "moment-timezone";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import SVG from "react-inlinesvg";

import { useAddAltermatedMaterial } from "./EditAlternatedContext";
import { ALT_MATERIAL_TYPE } from "./EditItem";
import useStyles from "./styles";
interface MATERIAL_PRIORITY {
  materialOsId: string;
  id: number;
  priority?: number;
  displayText?: string;
  disabled?: boolean;
  dia?: any;
}

interface MaterialPrioridyComponentProps {
  onRemove: (id: number) => void;
  id: number;
  value: MATERIAL_PRIORITY;
  handleChange: (id: number, fieldName: string, value) => void;
  isShowDeleteButton: boolean;
  priority?: number;
  errorMsg?: string;
  defaultValue: any;
  defaultInputValue: string;
  isClean?: boolean;
  saleOrganization?: string;
  isSaleOrgChanges?: boolean;
}

interface GradeGramPrioridyComponentProps {
  onRemove: (id: number) => void;
  id: number;
  value: MATERIAL_PRIORITY;
  handleChange: (id: number, fieldName: string, value) => void;
  isShowDeleteButton: boolean;
  priority?: number;
  errorMsg?: string;
  defaultValue: any;
  defaultInputValue: string;
  saleOrganization?: string;
  isSaleOrgChanges?: boolean;
}

const MaterialPriorityComponent: React.FC<MaterialPrioridyComponentProps> = ({
  onRemove,
  id,
  value,
  handleChange,
  isShowDeleteButton,
  errorMsg = "",
  priority,
  defaultValue,
  defaultInputValue,
  saleOrganization = "",
  isSaleOrgChanges
}) => {
  const classes = useStyles();
  const [
    getMaterialDataSuggestions,
    { data: materialDataSuggestions, loading: loadingMaterialDataSuggestion }
  ] = useMaterialOwnLazyQuery();
  const [isClean, setIsClean] = useState(false);

  const handleClean = () => {
    setIsClean(true);
    setTimeout(() => {
      setIsClean(false);
    }, 300);
  };
  const materialDataOptions = (
    mapEdgesToItems(materialDataSuggestions?.materialAlter) || []
  ).map(data => ({
    title: `${data.code}`,
    value: `${data.id}`
  }));

  const error = useMemo(() => {
    if (!value.materialOsId) {
      return "โปรดระบุข้อมูล";
    }
    if (errorMsg) {
      return errorMsg;
    }
    return "";
  }, [value?.materialOsId, errorMsg]);

  useEffect(() => {
    if (isSaleOrgChanges) {
      handleClean();
    }
  }, [isSaleOrgChanges]);

  return (
    <>
      <Box className={classes.priorityWrappers} key={id} id={`${id}`}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={isShowDeleteButton ? 11 : 12}
            style={{
              maxWidth: isShowDeleteButton ? "85%" : "99%",
              flexBasis: isShowDeleteButton ? "85%" : "99%"
            }}
          >
            <Box>
              <div className={classes.priorityHeaders}>
                <Box className={classes.flexs}>
                  <MyTypography variant={"subtitle3"}>
                    Alternated Material
                  </MyTypography>
                  <span className={classes.required}>*</span>
                </Box>
              </div>
              <div style={{ width: "100%" }}>
                <InputSuggestion
                  isClean={isClean}
                  searchField="materialCode"
                  dataOptions={materialDataOptions}
                  totalCount={materialDataOptions.length}
                  loadingDataSuggestion={loadingMaterialDataSuggestion}
                  getDataSuggestions={getMaterialDataSuggestions}
                  contained
                  isCheckingRole
                  name={"materialOsId"}
                  id={`materialOsId-${id}`}
                  testId={`materialOsId-${id}`}
                  placeholder={"ค้นหา Material OS"}
                  objectSuggestion
                  key={priority}
                  defaultValue={{
                    title: defaultValue.displayText,
                    value: defaultValue.materialOsId
                  }}
                  defaultInputValue={defaultInputValue}
                  error={!!error}
                  handleSelectedSearch={value => {
                    handleChange(id, "materialOsId", value.value);
                    handleChange(id, "displayText", value?.label);
                  }}
                  saleOrganization={saleOrganization}
                  resetInputValueOnBlur
                />
              </div>
              <div className={classes.textError}>{error}</div>
            </Box>
          </Grid>
        </Grid>
        {isShowDeleteButton && (
          <Grid item xs={12} md={2} className={classes.dragdrops}>
            <Box
              onClick={() => {
                onRemove(id);
                handleClean();
              }}
              className={classes.removeButtons}
            >
              <img src={Trash} alt="trash-icon"></img>
            </Box>
            <span className={`column-drag-handle ${classes.dragIcons}`}>
              <SVG
                color="#999999"
                height={"22px"}
                style={{ margin: "0 3px" }}
                src={DragIcon}
              />
            </span>
          </Grid>
        )}
      </Box>
    </>
  );
};

const GradeGramPriorityComponent: React.FC<GradeGramPrioridyComponentProps> = ({
  onRemove,
  id,
  value,
  handleChange,
  isShowDeleteButton,
  errorMsg = "",
  priority,
  defaultValue,
  defaultInputValue,
  saleOrganization = "",
  isSaleOrgChanges
}) => {
  const classes = useStyles();

  const [isClean, setIsClean] = useState(false);

  const handleClean = () => {
    setIsClean(true);
    setTimeout(() => {
      setIsClean(false);
    }, 300);
  };

  const [
    getGradeGramDataSuggestions,
    { data: gradeGramDataSuggestions, loading: loadingGradeGramDataSuggestion }
  ] = useGradeGramLazyQuery();

  const gradeGramDataOptions = (
    mapEdgesToItems(gradeGramDataSuggestions?.materialAlter) || []
  ).map(data => ({
    title: data.code,
    value: data.id,
    dia: data.dia
  }));

  const error = useMemo(() => {
    if (!value.materialOsId) {
      return "โปรดระบุข้อมูล";
    }
    if (errorMsg) {
      return errorMsg;
    }
    return "";
  }, [value?.materialOsId, errorMsg]);

  useEffect(() => {
    if (isSaleOrgChanges) {
      handleClean();
      value.dia = "";
    }
  }, [isSaleOrgChanges]);

  return (
    <>
      <Box className={classes.priorityWrappers}>
        <Grid container spacing={6}>
          <Grid
            item
            xs={12}
            md={isShowDeleteButton ? 5 : 6}
            style={{
              maxWidth: isShowDeleteButton ? "40%" : "47%",
              flexBasis: isShowDeleteButton ? "40%" : "47%"
            }}
          >
            <Box>
              <div className={classes.priorityHeaders}>
                <Box className={classes.flexs}>
                  <MyTypography variant={"subtitle3"}>
                    Alternated Grade/Gram
                  </MyTypography>
                  <span className={classes.required}>*</span>
                </Box>
              </div>
              <div className={classes.singletexts} style={{ width: "100%" }}>
                <InputSuggestion
                  isClean={isClean}
                  searchField="gradeGram"
                  dataOptions={gradeGramDataOptions}
                  totalCount={gradeGramDataOptions.length}
                  loadingDataSuggestion={loadingGradeGramDataSuggestion}
                  objectSuggestion
                  getDataSuggestions={getGradeGramDataSuggestions}
                  contained
                  isCheckingRole
                  name={"materialOsId"}
                  id={`materialOsId-${id}`}
                  testId={`materialOsId-${id}`}
                  placeholder={"ค้นหา Alternated Grade/Gram"}
                  error={!!error}
                  key={priority}
                  defaultValue={{
                    title: defaultValue.displayText,
                    value: defaultValue.materialOsId
                  }}
                  defaultInputValue={defaultInputValue}
                  handleSelectedSearch={selected => {
                    handleChange(id, "materialOsId", selected?.value);
                    handleChange(id, "displayText", selected?.title);
                  }}
                  saleOrganization={saleOrganization}
                  resetInputValueOnBlur
                />
              </div>

              <div className={classes.textError}>{error}</div>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={isShowDeleteButton ? 5 : 6}
            style={{
              maxWidth: isShowDeleteButton ? "40%" : "47%",
              flexBasis: isShowDeleteButton ? "40%" : "47%"
            }}
          >
            <Box>
              <div className={classes.priorityHeaders}>
                <Box className={classes.flexs}>
                  <MyTypography variant={"subtitle3"}>Dia</MyTypography>
                  <span className={classes.required}>*</span>
                </Box>
              </div>
              <div className={classes.singletexts} style={{ width: "100%" }}>
                <SingleTextField
                  error={!value.dia}
                  onChange={e => {
                    handleChange(id, "dia", e.target.value);
                  }}
                  onKeyPress={e => {
                    const charCodes = e.which ? e.which : e.keyCode;
                    const inputValues = e.target.value;
                    if (
                      (!/[0-9]/.test(e.key) &&
                        charCodes !== 8 &&
                        charCodes !== 46) ||
                      (inputValues.length >= 3 &&
                        charCodes !== 8 &&
                        charCodes !== 46)
                    ) {
                      e.preventDefault();
                    }
                  }}
                  placeholder="ระบุ Dia"
                  value={value.dia}
                  id={`dia-${id}`}
                  InputProps={{
                    inputProps: { "data-testid": `dia-${id}-input` }
                  }}
                />
              </div>
              {!value.dia && (
                <div className={classes.textError}>โปรดระบุข้อมูล</div>
              )}
            </Box>
          </Grid>
        </Grid>

        {isShowDeleteButton && (
          <Grid item xs={12} md={2} className={classes.dragdrops}>
            <Box
              onClick={() => {
                onRemove(id);
                handleClean();
              }}
              className={classes.removeButtons}
            >
              <img src={Trash} alt="trash-icon"></img>
            </Box>
            <span className={`column-drag-handle ${classes.dragIcons}`}>
              <SVG
                color="#999999"
                height={"22px"}
                style={{ margin: "0 3px" }}
                src={DragIcon}
              />
            </span>
          </Grid>
        )}
      </Box>
    </>
  );
};

const MaterialPriorityWrapperComponent = ({
  type,
  saleOrganization,
  isSaleOrgChanges
}) => {
  const classes = useStyles();
  const [priorities, setPriorities] = useState<MATERIAL_PRIORITY[]>([]);
  const { formik } = useAddAltermatedMaterial();
  const { priority } = formik.values;
  useEffect(() => {
    setPriorities(priority);
  }, []);

  const handleAddPriority = priority => {
    const newPriorities = [...priorities];

    const id = moment().valueOf();
    const newItem: MATERIAL_PRIORITY = {
      materialOsId: "",
      id,
      priority,
      displayText: "",
      disabled: false
    };

    newPriorities.push(newItem);
    setPriorities(newPriorities);
    formik.setFieldValue("priority", newPriorities);
  };

  const handleChangePriority = useCallback(
    (id: number, fieldName: string, value) => {
      if (id && fieldName) {
        const newPriorities = priorities.map(p => {
          if (p?.id === id) {
            p[fieldName] = value;
          }
          return p;
        });

        formik.setFieldValue("priority", newPriorities);
        setPriorities(newPriorities);
      }
    },
    [priorities]
  );
  const handleRearrangePriorties = (removeIndex, addedIndexs) => {
    const tempPriority = [...priorities];

    const targetPriority = priorities[removeIndex];
    if (addedIndexs <= removeIndex) {
      for (let i = removeIndex; i > addedIndexs; i--) {
        tempPriority[i] = tempPriority[i - 1];
      }
    } else {
      for (let i = removeIndex; i < addedIndexs; i++) {
        tempPriority[i] = tempPriority[i + 1];
      }
    }

    tempPriority[addedIndexs] = targetPriority;
    for (let i = 0; i < tempPriority.length; i++) {
      tempPriority[i].priority = i;
    }

    formik.setFieldValue("priority", tempPriority);
    setPriorities(tempPriority);
  };
  const handleRemovePriority = useCallback(
    (id: number) => {
      if (id) {
        const newPriorities = priorities.filter(p => p?.id !== id);
        formik.setFieldValue("priority", newPriorities);
        setPriorities(newPriorities);
      }
    },
    [priorities]
  );

  const PrioridyComponent = useMemo(
    () =>
      type === ALT_MATERIAL_TYPE.MATERIAL
        ? MaterialPriority
        : GradeGramPriority,
    [type]
  );

  return (
    <>
      <Grid container className={classes.priorityDivs}>
        <Grid item className={classes.priorityLabel}>
          <Box>
            {" "}
            {priorities.map(
              p =>
                p.id &&
                !p.disabled && (
                  <Box
                    mb={2}
                    key={p.id}
                    style={{ height: p.materialOsId ? 110 : 120 }}
                    className={classes.flexs}
                  >
                    <MyTypography
                      variant="subtitle3"
                      className={classes.fontStyles}
                    >
                      <span style={{ display: "inline", whiteSpace: "nowrap" }}>
                        {`Priority ${priorities
                          .filter(e => !e.disabled)
                          .findIndex(e => e.id === p.id) + 1}`}
                      </span>
                    </MyTypography>
                  </Box>
                )
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={10} className={classes.priorityBox}>
          <DragHandle
            handleRearrangePriorty={handleRearrangePriorties}
            itemsToRender={priorities.map(p => ({
              id: p.id,
              element: !p.disabled && (
                <Box
                  mb={2}
                  key={p.id}
                  style={{
                    width: "100%",
                    height: p.materialOsId ? 110 : 120
                  }}
                >
                  <Box className={classes.flexs} alignItems="center">
                    <MyTypography variant={"subtitle3"}></MyTypography>
                  </Box>
                  <PrioridyComponent
                    isShowDeleteButton={
                      priorities.filter(e => !e.disabled).length > 1
                    }
                    value={p}
                    defaultValue={p}
                    defaultInputValue={p.displayText}
                    handleChange={handleChangePriority}
                    onRemove={handleRemovePriority}
                    id={p?.id}
                    key={p.id}
                    priority={p.id}
                    saleOrganization={saleOrganization}
                    isSaleOrgChanges={isSaleOrgChanges}
                  />
                </Box>
              )
            }))}
          />
        </Grid>
      </Grid>

      <Box
        className={classes.addingstylepriors}
        style={{
          justifyContent: priorities.length < 5 ? "space-between" : "flex-end"
        }}
      >
        <Box
          onClick={
            priorities.length < 5
              ? () => handleAddPriority(priorities.length)
              : undefined
          }
          mt={1}
          className={classes.addPrioritys}
          style={{
            display: priorities.length < 5 ? "flex" : "none"
          }}
        >
          <SVG stroke="#009FB8" height={"18px"} src={plusIcon} />{" "}
          <span
            style={{
              whiteSpace: "nowrap"
            }}
          >
            Add Priority
          </span>
        </Box>
        <Box
          className={classes.singleLineMessages}
          style={{ display: priorities.length > 1 ? "flex" : "none" }}
        >
          <MyTypography
            variant="body3"
            align={"center"}
            className={classes.typo}
          >
            Press and hold{" "}
          </MyTypography>
          <SVG
            color="#999999"
            height={"18px"}
            style={{ margin: "0 3px" }}
            src={DragIcon}
          />
          <MyTypography
            variant="body3"
            align={"center"}
            className={classes.typo}
          >
            {" "}
            to drag and drop the Priority Card
          </MyTypography>
        </Box>
      </Box>
    </>
  );
};

const MaterialPriorityWrapper = memo(MaterialPriorityWrapperComponent);
const GradeGramPriority = memo(GradeGramPriorityComponent);
const MaterialPriority = memo(MaterialPriorityComponent);

export default MaterialPriorityWrapper;
